import SpineWrapper from '@Core/Animation/SpineWrapper';
import { BoundingBoxAttachment } from '@esotericsoftware/spine-pixi-v8';
import { FederatedPointerEvent, Point, Polygon } from 'pixi.js';

export const isBoundingBoxClicked = (spineWrapper: SpineWrapper, slotName: string, pointer: FederatedPointerEvent): boolean => {
    const slot = spineWrapper.spine.skeleton.findSlot(slotName);

    if (!slot) {
        return false;
    }

    const attachment = slot.pose.getAttachment();
    const boundingBox = attachment as BoundingBoxAttachment;
    const slotWorldVertsLength = boundingBox.worldVerticesLength;
    const slotWorldVertices: number[] = new Array(slotWorldVertsLength);

    boundingBox.computeWorldVertices(slot.skeleton, slot, 0, slotWorldVertsLength, slotWorldVertices, 0, 2);

    const polygonPoints: Point[] = [];

    for (let i = 0; i < slotWorldVertices.length; i += 2) {
        const point = new Point(slotWorldVertices[i], slotWorldVertices[i + 1]);
        polygonPoints.push(spineWrapper.spine.toGlobal(point));
    }

    const polygon = new Polygon(polygonPoints);

    return polygon.contains(pointer.x, pointer.y);
};
